import { css } from '@emotion/react'

export const fieldsetStyles = css`
  min-height: 95px;
`

export const fieldStyles = css`
  height: 40px;
  transition: all 200ms ease-in;
`

export const labelStyles =
  ({ theme }) => css`
    display: block;
    margin-left: 22px;
    color: ${theme.colors.n800};
    font-weight: ${theme.font.weight.semibold};
    font-size: 12px;
  `

export const placeholderStyles =
  ({ theme }) => css`
    display: block;
    margin-left: 22px;
    margin-bottom: ${theme.spacings.byte};
    color: ${theme.colors.n400};
    font-size: 12px;
  `
export const messageStyles =
  ({ theme }) => css`
    display: block;
    margin-left: 22px;
    margin-bottom: ${theme.spacings.byte};
    color: ${theme.colors.r500};
    font-size: 12px;
  `
